export interface Props {
  type: 'error' | 'info' | 'warn' | 'success';
  fill: string;
}

export default function Icon({ type, fill }: Props) {
  switch (type) {
    case 'error':
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill={fill}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 0C8.96 0 0 8.96 0 20C0 31.04 8.96 40 20 40C31.04 40 40 31.04 40 20C40 8.96 31.04 0 20 0ZM20 22C18.9 22 18 21.1 18 20V12C18 10.9 18.9 10 20 10C21.1 10 22 10.9 22 12V20C22 21.1 21.1 22 20 22ZM22 30H18V26H22V30Z"
            fill={fill}
          />
        </svg>
      );
    case 'success':
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill={fill}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 0C8.96 0 0 8.96 0 20C0 31.04 8.96 40 20 40C31.04 40 40 31.04 40 20C40 8.96 31.04 0 20 0ZM14.58 28.58L7.4 21.4C6.62 20.62 6.62 19.36 7.4 18.58C8.18 17.8 9.44 17.8 10.22 18.58L16 24.34L29.76 10.58C30.54 9.8 31.8 9.8 32.58 10.58C33.36 11.36 33.36 12.62 32.58 13.4L17.4 28.58C16.64 29.36 15.36 29.36 14.58 28.58Z"
            fill={fill}
          />
        </svg>
      );
    default:
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill={fill}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 0C8.96 0 0 8.96 0 20C0 31.04 8.96 40 20 40C31.04 40 40 31.04 40 20C40 8.96 31.04 0 20 0ZM20 30C18.9 30 18 29.1 18 28V20C18 18.9 18.9 18 20 18C21.1 18 22 18.9 22 20V28C22 29.1 21.1 30 20 30ZM22 14H18V10H22V14Z"
            fill={fill}
          />
        </svg>
      );
  }
}
